<h2
  class="company-info-heading-pdf"
  style="font-size: 20px; margin: 20px 0; font-weight: bold"
>
  Service Agreement
</h2>

<p style="margin: 12px 0">
  The U.S. Department of Transportation (DOT) has published rules requiring DOT
  covered employers to test certain employees under certain circumstances for
  the presence of certain prohibited drugs and alcohol and to provide such
  employees with an employee assistance program.
  The {{ CompanyName }}
  is subject to performing covered employee functions under and subject to the
  aforesaid rules and is required and desires to comply with said DOT
  requirements and/or
  the {{ CompanyName }}
  is an employer conducting NON-DOT drug and alcohol testing and wishes to adopt
  an Alcohol and Drug Program pursuant to the DOT regulations and/or
  {{ CompanyName }}
  NON-DOT requirements.
</p>

<p style="margin: 12px 0">
  {{ CompanyName }}
  desires to engage Pipeline Testing Consortium, Inc. (PTC), a Kansas
  Corporation, and PTC desires to be engaged to assist
  {{ CompanyName }}
  in administering their Alcohol and Drug programs and desires to contract with
  the {{ CompanyName }}
  to assist, and act as
  <span>{{ CompanyName }}</span
  >’s agent, in administering its program by administering the Testing
  (pre-employment, post-accident, at random, reasonable cause, return-to-duty or
  follow-up) Employee Assistance Program, and Recordkeeping functions of the
  DOT regulations and/or NON-DOT requirements. PTC wishes to enlist
  {{ CompanyName }}
  in a Consortium of DOT-regulated employers and/or NON-DOT employers for
  greater efficiency in compliance with said regulations and/or
  {{ CompanyName }}
  requirements.
</p>

<p style="margin: 12px 0">
  <span style="font-weight: bold">THEREFORE,</span>
  {{ CompanyName }}
  hereby contracts with PTC to administer the Alcohol and Drug Testing, Employee
  Assistance Program, and Recordkeeping functions required of
  {{ CompanyName }}
  by the DOT regulations and/or NON-DOT requirements, upon the following terms
  and conditions:
</p>
<ul style="padding-left: 20px; margin: 12px 0">
  <li style="margin-bottom: 12px">
    <span style="font-weight: bold">SERVICES.</span>
    PTC will provide
    {{ CompanyName }}
    with an Alcohol and Drug Program that is intended to be adopted and used by
    {{ CompanyName }}
    in conjunction with its business as an operator or contractor under the
    applicable DOT regulations and/or
    {{ CompanyName }}
    NON-DOT requirements.
    {{ CompanyName }}
    hereby agrees to execute through PTC a Drug Testing and Service Agreement
    with Clinical Reference Laboratory, 8433 Quivira Road, Lenexa, Kansas,
    66215, and to name and appoint David Paine, MD of American Medical Review
    Officers, LLC, 9 Compound Drive, Hutchinson, KS, 67502 as its Medical Review
    Officer pursuant to the DOT regulations (collectively the “Services”). The
    {{ CompanyName }}
    agrees that PTC shall be the exclusive provider of the Services during the
    Term of this Agreement.
  </li>

  <li style="margin-bottom: 12px">
    <span style="font-weight: bold">MEMBERSHIP IN CONSORTIUM.</span> Subject to
    the terms and conditions of this Agreement, PTC will enlist
    {{ CompanyName }}
    in, and
    {{ CompanyName }}
    agrees to be listed as, a member of a Consortium (or group) of DOT-regulated
    employers and/or NON-DOT employers who have or will individually contract
    with PTC for similar services.
  </li>
</ul>
